import { graphql } from "gql";

const HAPPYCO_EXPORT_TO_WORK_ORDER_MUTATION = graphql(`
  mutation HappycoExportToWorkOrder($input: HappycoExportToWorkOrderInput!) {
    happycoExportToWorkOrder(input: $input) {
      ...HappycoWorkOrder
    }
  }
`);

export default HAPPYCO_EXPORT_TO_WORK_ORDER_MUTATION;
